import React from "react";
import { useSelector } from "react-redux";
import App from "./App";
import "bootstrap/dist/css/bootstrap.css";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { Appointment, Cart, Checkout, Home, Login, MyAppointments, ProductList, Profile, Return, SingleOrder, Wishlist } from "./pages";
import 'bootstrap/dist/css/bootstrap.min.css';
import SingleProduct from "./pages/SingleProduct";
const RoutePages = () => {
    const router = createBrowserRouter([
        {
          path: "/",
          element: <App />,
          errorElement: <div>error occurred in App</div>,
          children: [
            {
              path: "",
              exact: true,
              element: <Home />,
            },
            {
              path: "login",
              element: <Login />,
            },
            {
              path: "productlist/:gender/:category/:subcategory",
              exact: true,
              element: <ProductList />,
            },
            {
              path: "productlist/collection/:gender/:collection",
              exact: true,
              element: <ProductList />,
            },
            {
              path: "productlist/discount/:discount",
              exact: true,
              element: <ProductList />,
            },
            {
              path: "/:name/:id",
              exact: true,
              element: <SingleProduct />,
            },
            {
              path: "cart",
              exact: true,
              element: <Cart />,
            },
            {
              path: "checkout",
              exact: true,
              element: <Checkout />,
            },
            {
              path: "wishlist",
              exact: true,
              element: <Wishlist />,
            },
            {
              path: "profile",
              exact: true,
              element: <Profile />,
            },
            {
              path: "profile/order/:orderid",
              exact: true,
              element : <SingleOrder />
            },
            {
              path: "return/:orderid",
              exact: true,
              element : <Return />
            },
            {
              path: "appointment",
              exact: true,
              element : <Appointment />
            },
            {
              path: "myappointments",
              exact: true,
              element : <MyAppointments />
            }
          ],
        },
      ]);
    const darknavbar = useSelector(state => state.auth.header.darknavbar);
      if(darknavbar){
        document.documentElement.style.setProperty('--primary-color',"#ffffff");
        document.documentElement.style.setProperty('--secondary-color',"#431120");

        document.documentElement.style.setProperty('--button-color',"#464646");
        document.documentElement.style.setProperty('--light-color',"#8c5263");
        document.documentElement.style.setProperty('--dark-color',"#FBE7EF");
        document.documentElement.style.setProperty('--inputfield-scheme',"light");
        document.documentElement.style.setProperty('--success',"#074E17");
        document.documentElement.style.setProperty('--rgbasuccessopacity',"rgba(9, 14, 10, 0.3)");
        document.documentElement.style.setProperty('--third-color',"#DEA293");
      }
      else{
        document.documentElement.style.setProperty('--secondary-color',"#ffffff");
        document.documentElement.style.setProperty('--third-color',"#DEA293");

        document.documentElement.style.setProperty('--primary-color',"#431120");
        
        document.documentElement.style.setProperty('--button-color',"#c9c9c9");
        document.documentElement.style.setProperty('--light-color',"#FBE7EF");
        document.documentElement.style.setProperty('--dark-color',"#8c5263");
        document.documentElement.style.setProperty('--inputfield-scheme',"dark");
        document.documentElement.style.setProperty('--success',"#6CE87B");
        document.documentElement.style.setProperty('--rgbasuccessopacity',"rgba(108, 232, 123, 0.5)");

      }

      //       if(darknavbar){
      //   document.documentElement.style.setProperty('--primary-color',"#ffffff");
      //   document.documentElement.style.setProperty('--secondary-color',"#104822");

      //   document.documentElement.style.setProperty('--button-color',"#464646");
      //   document.documentElement.style.setProperty('--light-color',"#4a8a5e");
      //   document.documentElement.style.setProperty('--dark-color',"#e8ffef");
      //   document.documentElement.style.setProperty('--inputfield-scheme',"light");
      //   document.documentElement.style.setProperty('--success',"#074E17");
      //   document.documentElement.style.setProperty('--rgbasuccessopacity',"rgba(9, 14, 10, 0.3)");
      //   document.documentElement.style.setProperty('--third-color',"#b9de93");
      // }
      // else{
      //   document.documentElement.style.setProperty('--secondary-color',"#ffffff");
      //   document.documentElement.style.setProperty('--third-color',"#b9de93");

      //   document.documentElement.style.setProperty('--primary-color',"#104822");
        
      //   document.documentElement.style.setProperty('--button-color',"#c9c9c9");
      //   document.documentElement.style.setProperty('--light-color',"#e8ffef");
      //   document.documentElement.style.setProperty('--dark-color',"#4a8a5e");
      //   document.documentElement.style.setProperty('--inputfield-scheme',"dark");
      //   document.documentElement.style.setProperty('--success',"#6CE87B");
      //   document.documentElement.style.setProperty('--rgbasuccessopacity',"rgba(108, 232, 123, 0.5)");

      // }
      
    return(
        <RouterProvider router={router} />

    )
}

export default RoutePages